module.exports = __webpack_public_path__ + "static/potrebujetezamestnance-499e84ad54dd5688e04dcc78f18ca889.png";